<template>
    <div class="page-tour">
        <div class="container">
            <div class="gr-12">
                <div class="wysiwyg">
                    <h3>Take a tour</h3>
                    <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Quis, molestiae modi accusantium animi magnam veniam, impedit asperiores sint consequuntur debitis fugit quibusdam dolor, iusto sed porro ab minus voluptatibus amet.</p>
                </div>
            </div>
        </div>

        <Prefooter />
        <Footer />
    </div>
</template>

<script>
// components
import Prefooter from '@/components/Prefooter.vue';
import Footer from '@/components/Footer.vue'

    export default {
        components: {
            Prefooter,
            Footer
        },

        data() {
            return {}
        }
    };
</script>


<style scoped lang="scss">
    
</style>